import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { Login } from './Login';
import { getToken } from './api';
import './index.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5_000, refetchOnWindowFocus: false },
  },
});

function Root() {
  const [hasToken, setHasToken] = useState<boolean>(() => getToken() !== '');
  if (!hasToken) {
    return <Login onAuthed={() => setHasToken(true)} />;
  }
  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <Root />
    </QueryClientProvider>
  </React.StrictMode>,
);
